import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom"; // Import useNavigate
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
import Logo from "../../../assets/logos/brandLogo.svg";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import Tooltip from "@mui/material/Tooltip";
import NavSearchInput from "../../common/commonSearch/navSearchInput";
import ProfilePic from "../../../assets/images/profilePic.png";
import { Avatar, Badge, Menu, MenuItem } from "@mui/material";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { loginDetails } from "../../../redux/slices/authSlice";
import { getUserByID } from "../../../services/userManagementServices/userServices";
import NotificationPopover from "../../../pages/Dashboard/notificationModal";
import { io } from "socket.io-client";
import { setNotificationStatus } from "../../../redux/slices/dashboardSlice";
import { getAccessibleModules, NAV_ITEMS } from "../../../constants/permissions";
import { setUserDetail } from "../../../redux/slices/userSlice";
import { navArray } from "../../../utils/globalData";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { logOutAPI } from "../../../services/authServices";
import { paidStatus } from "../../../redux/slices/paymentSlice";

const drawerWidth = 70;

export default function NavBar() {
  const navigate = useNavigate(); // Hook for navigation
  const dispatch = useDispatch();
  const location = useLocation();
  const email = Cookies.get()?.email || "";
  const userId = Cookies.get()?.userId || "";
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const { notificationStatus } = useSelector((state: any) => state.dashboard);
  const { getUserData } = useSelector((state: any) => state.user);
  const [notifyAnchorEl, setnotifyAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [userDetails, setUserDetails] = useState<any>({});
  const [unreadCount, setUnreadCount] = useState<any>({
    count: 0,
    unreadCount: 0,
    notifications: [],
  }); 
  const [permissionModalOpen, setPermissionModalOpen] = useState(false);

  const handleClick = (event: any) => {
    setnotifyAnchorEl(event.currentTarget);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!userId) return;
    (async () => {
      try {
        const { data } = await getUserByID(userId);
        // console.log(data, "getUserByIDgetUserByID>>");
        setUserDetails(data);
              dispatch(setUserDetail(data));
      } catch (err) {
        console.error("Failed to load user:", err);
      }
    })();
  }, [userId]);

// Update the permittedNav useMemo:
const permittedNav = useMemo(() => {
  // Use the utility function to get accessible modules
  return getAccessibleModules(
    userDetails?.role?.permissions,
    userDetails?.role?.name,
    NAV_ITEMS
  );
}, [userDetails]);

  const permittedNav1 = useMemo(() => {
    // Return all items for admin
    if (userDetails?.role?.name === "admin") return navArray;

    if (!userDetails?.role?.permissions) return [];

    return navArray.filter((menu) => {
      // Always include dashboard
      if (menu.label === "dashboard") return true;
      
    // ❌ Restrict Reports only to admin
    if (menu.moduleName === "Reports") return false;

      // Check if user has permission for the module
      const perm = userDetails.role.permissions.find(
        (p: any) => p.module === menu.moduleName
      );

      // Allow if any section has view: true
      return perm?.section?.some((sec: any) => sec.actions?.view) ?? false;
    });
  }, [userDetails, navArray]);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }
  }, [location.pathname, navigate]);

  const [selectedId, setSelectedId] = React.useState<string | number>("");

  const handleLogout = async() => {
    try {
      const payload={}
      const { data } = await logOutAPI(payload);
    } catch (err) {
      console.error("Failed to load user:", err);
    }
    // Cookies.remove();
    dispatch(loginDetails({}));
    Cookies.set("ur", "0");
    // Optional: If you want to manually clear specific cookies
    Cookies.remove("access_token");
    Cookies.remove("email");
    Cookies.remove("userId");
    Cookies.remove("role");
    Cookies.remove("role_id");
    Cookies.remove("enquiryId");
    Cookies.remove("eventId");
    Cookies.remove("companyId");
    Cookies.remove("isNotificationEnabaledOrAskedAlready");
    localStorage.removeItem("xero_tokens");
    window.location.href = "/";
  };

  // console.log(location?.pathname, "location");

  const handleNotificationScroll = (e: any) => {
    const bottom =
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop ===
      e.currentTarget.clientHeight;

    // if (bottom) {
    //   fetchMoreNotifications(); // implement your own pagination logic
    // }
  };

  // socket commented live connection issue local working fine
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (permissionModalOpen) {
        handleLogout();
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [permissionModalOpen]);
  
  useEffect(() => {
    if (!userId) return; // Don't connect if no userId
    const socket = io(import.meta.env.VITE_SOCKET_URL, {
      path: "/socket.io",
      autoConnect: false,
      transports: ["websocket"],
      auth: {
        token: Cookies.get()?.access_token // Use your actual token
      }
    });
    // const socket = io("wss://api-awsm.colanonline.net", {
    //   path: "/socket.io",
    //   autoConnect: false,
    //   transports: ["websocket"],
    //   auth: {
    //     token: Cookies.get()?.access_token // Use your actual token
    //   }
    // });

    // Connection handlers
    socket.on("connect", () => {
      console.log("Socket connected:", socket.id);
      // Emit startNotifications with userId to the server
      socket.emit("startNotifications", { userId });
      socket.on("newNotifications", notificationListener);
    });

    socket.on("connect_error", (err) => {
      console.error("Connection error:", err);
    });

    // Notification handler
    const notificationListener = (data: any) => {
      // console.log("New notifications:", data);
      const roleId = Cookies.get()?.role_id;
// ✅ Desktop Notification
// if (Notification.permission === "granted") {
//   const latestNotification =
//     data?.notification ||
//     (Array.isArray(data?.notifications) && data.notifications[0]);

//   if (latestNotification) {

//     const notification = new Notification(
//       latestNotification.title || "New Notification",
//       {
//         body:
//           latestNotification.message ||
//           "You have received a new notification",
//         icon: "/favicon.ico",
//       }
//     );

//     // ✅ Redirect on click
//     notification.onclick = () => {
//       window.focus();

//       // optional link from API
//       if (latestNotification) {
//         const url = new URL(latestNotification.link);

//         const frontendPath =  import.meta.env.VITE_FRONTEND_URL;

//         window.location.href =
//           `${window.location.origin}${frontendPath}`;
//       } else {
//         window.location.href = window.location.origin;
//       }
//     };
//   }
// }
      if (
        data?.notification?.type === "permission_update_notification" &&
        data?.notification?.role_id === roleId
      ) {
        setPermissionModalOpen(true);
        return;
      }
      if(data?.notification?.type === "payment"){
      dispatch(paidStatus(true))
      }
      if (
        (Array.isArray(data.notifications) && data.notifications.some((n:any) => n.userId === userId)) ||
        (data.notification && data.notification.userId === userId)
      ){
        setUnreadCount((prev: any) => {
          // Handle the nested array structure (where notifications[0] contains the actual array)
          const normalizedNotifications = Array.isArray(data.notifications) &&
            data.notifications.length > 0 &&
            Array.isArray(data.notifications[0])
            ? data.notifications[0] // Take the first array if nested
            : data.notifications || []; // Otherwise use notifications directly or empty array
  
          // Handle single notification updates
          const newNotifications = normalizedNotifications.length > 0
            ? normalizedNotifications
            : data.notification
              ? [data.notification]
              : [];
  
          // Create a Map to deduplicate by _id (preserves order)
          const notificationMap = new Map();
  
          // First add all new notifications (reversing to maintain chronological order)
          [...newNotifications].forEach((n: any) => {
            if (n._id) notificationMap.set(n._id, n);
          });
  
          // Then add existing notifications (won't overwrite newer ones)
          prev.notifications?.forEach((n: any) => {
            if (n._id && !notificationMap.has(n._id)) {
              notificationMap.set(n._id, n);
            }
          });
  
          // Convert back to array (newest first)
          const uniqueNotifications = Array.from(notificationMap.values()).reverse();
  
          return {
            count: data.count ?? prev.count,
            unreadCount: data.unreadCount ?? prev.unreadCount,
            notifications: uniqueNotifications
          };
        });
      }      
    };

    if (notificationStatus) {
      // socket.on("newNotifications", notificationListener);
      dispatch(setNotificationStatus(false))
    }
    // Error handler
    socket.on("notificationErrors", (error) => {
      console.error("Notification error:", error);
    });

    // Connect the socket
    socket.connect();

    // Cleanup
    return () => {
      socket.off("newNotifications", notificationListener);
      socket.off("connect");
      socket.off("connect_error");
      socket.off("notificationErrors");
      socket.disconnect();
    };
  }, [userId, notificationStatus]);

  // Reconnect if userId changes
  const getInitial = (name?: string) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase();
  };

  // Use a memoized value for unread notification status
const shouldShowUnreadBadge = useMemo(() => {
  // Check both local and Redux state for consistency
  return userDetails?.unReadNotification || getUserData?.unReadNotification || false;
}, [userDetails?.unReadNotification, getUserData?.unReadNotification]);

  return (
    <>
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#F3F3F3",
        maxHeight: "100vh",
        minWidth: "100%",
      }}
    >
      {/* <CssBaseline /> */}
      {location?.pathname !== "/enquiry-form" ? (
        <>
          <AppBar
            // sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            className="!bg-white !h-[3.5rem] !shadow-none flex justify-center"
          >
            <Toolbar
              sx={{
                alignItems: "center",
                minHeight: "56px !important",
                height: "56px",
              }}
            >
              <div className="flex flex-wrap justify-between text-[#151B2D] text-[0.8rem] !ml-[1rem] !pl-[4%] w-[100%]">
                <div className="flex gap-4 ">
                  <NavSearchInput
                    placeholder={"Search"}
                    inputStyle="h-[2.2rem]"
                  />
                </div>
                <div className="flex !pr-[1.5%] items-center gap-3 cursor-pointer">
                {shouldShowUnreadBadge ? (
                  <Badge
                    badgeContent={unreadCount.unreadCount || 0}
                    color="error"
                    max={99} 
                    sx={{
                      '& .MuiBadge-badge': {
                        right: 2,
                        top: 5,
                        fontSize: '0.6rem',  // Smaller font size
                        height: '16px',      // Smaller height
                        minWidth: '16px',    // Smaller width
                        padding: '0 2px',    // Less padding
                      }
                    }}
                  >
                    <CircleNotificationsIcon
                      color="primary"
                      sx={{ fontSize: "1.5rem", cursor: "pointer" }}
                      onClick={handleClick}
                    />
                  </Badge>
                ) : (
                  <CircleNotificationsIcon
                    color="primary"
                    sx={{ fontSize: "1.5rem", cursor: "pointer" }}
                    onClick={handleClick}
                  />
                )}
                  <NotificationPopover
                    anchorEl={notifyAnchorEl}
                    onClose={() => setnotifyAnchorEl(null)}
                    notifications={unreadCount}
                    handleScroll={handleNotificationScroll}
                    setUnreadCount={setUnreadCount}
                  />
                  { userDetails?.role?.name === "admin" ? <Avatar
                    src={ProfilePic}
                    alt="User"
                    sx={{
                      width: 35,
                      height: 35,
                      cursor: "pointer",
                      objectFit: "cover",
                    }}
                  /> :
                  <Avatar
                    alt="User"
                    sx={{
                      width: 35,
                      height: 35,
                      bgcolor: "#1976d2", // optional
                      cursor: "default",
                      objectFit: "cover",
                    }}
                  >
                    {getInitial(getUserData &&
  Object.keys(getUserData).length > 0 ? getUserData.username  :userDetails?.username)}
                  </Avatar>}
                  <div className="text-black">
                    {getUserData &&
  Object.keys(getUserData).length > 0 ? getUserData.username  :userDetails?.username || email ? (
                      <p className="text-[0.8rem]">
                        {getUserData &&
  Object.keys(getUserData).length > 0 ? getUserData.username  :userDetails?.username || email}
                      </p>
                    ) : (
                      <div className="w-[80px] h-[1rem] bg-gray-300 rounded animate-pulse" />
                    )}
                  </div>
                  <button
                    onClick={handleMenuOpen}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                  >
                    <ExpandCircleDownOutlinedIcon
                      sx={{
                        fontSize: "1.5rem",
                        color: "#5C5C5C",
                        "&:hover": {
                          color: "#3983DD",
                        },
                      }}
                    />
                  </button>

                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        handleLogout();
                        handleMenuClose();
                      }}
                    >
                      <p className="text-[0.8rem] text-primaryColor">Logout</p>
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: drawerWidth,
                boxSizing: "border-box",
                backgroundColor: "#060D15",
              },
              overflowX: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 3,
                py: 1, // optional spacing
              }}
            >
              <img src={Logo} alt="" className="!mt-[0.5rem] w-[1.9rem]" />
              <List>
                {permittedNav.map((menu) => {
                  const isSelected = location.pathname.includes(menu.label);
                  return (
                    <ListItem
                      key={menu.id}
                      disablePadding
                      onClick={() => {
                        setSelectedId(menu.id);
                        navigate(menu.route);
                      }}
                      sx={{
                        justifyContent: "center",
                      }}
                    >
                      <Tooltip title={menu.toolTipName} placement="right">
                        <Box
                          sx={{
                            mb: "0.5rem",
                            p: 1,
                            borderRadius: "5px",
                            backgroundColor: isSelected
                              ? "#3983DD"
                              : "transparent",
                            "&:hover": {
                              backgroundColor: isSelected
                                ? "#2B72F8"
                                : "#3983DD59",
                            },
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 40,
                            height: 40,
                            transition: "background-color 0.3s ease",
                          }}
                          className="cursor-pointer"
                        >
                          <img
                            src={menu.menuImg}
                            alt={menu.toolTipName}
                            style={{
                              width: 20,
                              height: 20,
                              filter: isSelected
                                ? "brightness(100%)"
                                : "brightness(70%)",
                            }}
                          />
                        </Box>
                      </Tooltip>
                    </ListItem>
                  );
                })}
              </List>
              <Divider />
            </Box>
          </Drawer>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              pt: "4.35rem",
              pl: 2,
              pr: 3,
              pb: 2,
              height: "100vh",
            }}
          >
            {/* <Toolbar /> */}
            {/* <SupplierDashBoard /> */}
            <Outlet />
          </Box>
        </>
      ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pt: "1.35rem",
            pl: 2,
            pr: 3,
            pb: '1.35rem',
            height: "100vh",
          }}
        >
          <Outlet />
        </Box>
      )}
    </Box>
    <Dialog
  open={permissionModalOpen}
  disableEscapeKeyDown
  onClose={() => {}}
>
  <DialogTitle>Permission Updated</DialogTitle>
  <DialogContent>
    Your role permission have been updated. Please login to continue.
  </DialogContent>
  <DialogActions>
    <Button
      variant="contained"
      color="primary"
      onClick={handleLogout}
    >
      Login
    </Button>
  </DialogActions>
</Dialog>
</>
  );
}
